/****************************************************
 * Module Name:  consignmentDetailModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import Utility from "../../utility/utility";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import SendIcon from '@mui/icons-material/Send';

function ConsignmentDetailModal({
    showModal,
    setShowModal,
    handleClose,
    handleSave,
    selectionModel,
}) {
    const [showError, setShowError] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [stoneIds, setStoneIds] = useState(selectionModel.toString());
    const [consignmentno, setConsignmentno] = useState(null);
    const [consignmentDate, setConsignmentDate] = useState(null);

    const saveHandler = () => {
        setLoadingButton(true);
        if (stoneIds === "") {
            setShowError(true);
            setLoadingButton(false);
            return;
        } else {
            let data = prepareData();
            handleSave(data);
            setShowModal(false);
            setLoadingButton(false)
        }
    };

    const prepareData = () => {
        return {
            stoneids: stoneIds.split(","),
            consignmentdate: consignmentDate ? dayjs(consignmentDate).format('YYYY-MM-DD') : null,
            consignmentno: consignmentno,
        }
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    return (
        <div>

            <Modal
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                size="lg"
                enforceFocus={false}
                centered
            >
                <TabMenuSnackbar
                    show={showError}
                    message={"Please enter stone Ids."}
                    variant={"error"}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={closeErrorDialog}
                    title={"Error"}
                />
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Add Stone Ids
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label className="mt-2">
                        Stone ID: <sup style={{ color: "red" }}>*</sup>
                    </Form.Label>
                    <TextField
                        id="outlined-multiline-static"
                        label="Comma seperated Certificate Ids (required)"
                        multiline
                        fullWidth
                        rows={4}
                        value={stoneIds}
                        onChange={(e) =>
                            setStoneIds(Utility.ConvertNewLineToComma(e.target.value))
                        }
                    />
                    <Form.Label className="mt-2">
                        Consignment NO:
                    </Form.Label>
                    <TextField
                        id="outlined-multiline-static"
                        label="Comma seperated Certificate Ids (required)"
                        multiline
                        fullWidth
                        rows={1}
                        value={consignmentno}
                        onChange={(e) =>
                            setConsignmentno(Utility.ConvertNewLineToComma(e.target.value))
                        }
                    />
                    <Form.Label className="mt-2">
                        Consignment Date:
                    </Form.Label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={consignmentDate}
                            onChange={(newValue) => setConsignmentDate(newValue)}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                            inputFormat="DD/MM/YYYY"
                        />
                    </LocalizationProvider>
                </Modal.Body>
                <Modal.Footer>
                    <Box sx={{
                        "& .Mui-disabled": {
                            backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                            color: "rgba(0, 0, 0, 0.26) !important"
                        }
                    }}>
                        <LoadingButton
                            loading={loadingButton}
                            loadingPosition="start"
                            startIcon={<SendIcon size="large" />}
                            variant="contained"
                            sx={{ mr: 2 }}
                            onClick={saveHandler}
                            type="Submit"
                        >
                            Mark As Sent
                        </LoadingButton>
                    </Box>
                    <Button disabled={loadingButton} variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ConsignmentDetailModal;
